import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, BookOpen, Play, X } from 'lucide-react';
import './OnboardingHelpBanner.css';

const STORAGE_KEY = 'cd365_onboarding_banner';
const BANNER_DAYS = 14;

function shouldShowBanner(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dismissed') return false;
  if (!stored) {
    // First visit — store the timestamp
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    return true;
  }
  // Check if within 14 days
  const firstSeen = parseInt(stored, 10);
  if (isNaN(firstSeen)) return false;
  const daysPassed = (Date.now() - firstSeen) / (1000 * 60 * 60 * 24);
  return daysPassed <= BANNER_DAYS;
}

interface Props {
  onOpenDemoTour?: () => void;
}

export default function OnboardingHelpBanner({ onOpenDemoTour }: Props) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(shouldShowBanner);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
    setVisible(false);
  };

  return (
    <div className="onboarding-banner card mb-16">
      <button className="onboarding-banner-close" onClick={dismiss} aria-label="Schließen">
        <X size={16} />
      </button>
      <div className="onboarding-banner-icon">
        <Sparkles size={22} />
      </div>
      <div className="onboarding-banner-body">
        <strong>Neu bei CoachDesk365?</strong>
        <span className="text-muted text-sm">
          Starten Sie mit dem Schnellstart-Guide oder sehen Sie sich die Demo an.
        </span>
      </div>
      <div className="onboarding-banner-actions">
        <button
          className="btn btn-sm btn-primary"
          onClick={() => navigate('/hilfe/schnellstart')}
        >
          <BookOpen size={14} />
          Schnellstart
        </button>
        {onOpenDemoTour && (
          <button
            className="btn btn-sm btn-outline"
            onClick={onOpenDemoTour}
          >
            <Play size={14} />
            Demo
          </button>
        )}
      </div>
    </div>
  );
}
